import { $userLanguage } from '@/entities/user'
import { $epicUserData } from '@/entities/platforms/egs/store'
import { lang } from '@/shared/constants/lang'
import { FormattedStat } from '@/shared/constants/types'
import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'

function useGetEpicStats() {
  const userLang = useUnit($userLanguage)

  const texts = lang[userLang].pages.epicProfile.stats
  const units = lang[userLang].pages.units
  const epicUserData = useUnit($epicUserData)

  const [stats, setStats] = useState<FormattedStat[]>([])

  useEffect(() => {
    setStats([
      { name: texts.accountValue, value: `${units.dollar}${epicUserData?.total_value_usd}`, diff: '0' },
      {
        name: texts.achievements,
        value: epicUserData?.total_achievements ?? 0,
        diff: epicUserData?.scoring_diff.achievements.toString() ?? '0',
      },
      {
        name: texts.gamesOwned,
        value: epicUserData?.games.length ?? 0,
        diff: epicUserData?.scoring_diff.games_owned.toString() ?? '0',
      },
      { name: texts.xp, value: epicUserData?.total_xp ?? 0, diff: epicUserData?.scoring_diff.xp.toString() ?? '0' },
    ])
  }, [userLang, epicUserData, texts.accountValue, texts.achievements, texts.gamesOwned, texts.xp, units.dollar])

  return stats
}

export default useGetEpicStats
